import './TrainLengthConfirmation.css'
import { useEffect } from 'react'
import { SuccessMessage } from '../../../Assets/Messages/Messages'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function TrainLengthConfirmation({length, speed, backToForm}) {
    useEffect(() => {
        const timeout = setTimeout(() => {
            backToForm()
        }, 5000)
        return () => {
            clearTimeout(timeout)
        }
    }, [backToForm])
    return <SuccessMessage
        title={"Longueur atteinte"}
        body={"Longueur de " + length + "m atteinte avec la vitesse de " + speed + "km/h"}
        buttonText={<FontAwesomeIcon icon="fa-solid fa-check" />}
        buttonOnClick={backToForm}
    />
}